import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import ArrowCircleRight from '@mui/icons-material/ArrowCircleRight';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

const MRNInput = ({ onClick, id, name, rowProps, disabled }) => {
  const { updateCurrentConsignment } = useContext(GBENSContext);
  const [inputValue, setInputValue] = useState('');

  const handleInputMRNChange = (event) => {
    updateCurrentConsignment(event, id);
    setInputValue(event.target.value);
  };

  const handleMRNClick = () => {
    onClick(inputValue);
  };

  return (
    <Row
      name={name}
      warning={false}
      component={
        <FormControl variant="standard" rowProps={rowProps} fullWidth>
          <TextField
            fullWidth
            id={id}
            value={inputValue}
            onChange={handleInputMRNChange}
            slotProps={{
              input: {
                endAdornment: !disabled && (
                  <InputAdornment position="end">
                    <IconButton onClick={handleMRNClick} edge="end">
                      <ArrowCircleRight sx={{ color: '#72BB53', fontSize: 30 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            disabled={disabled}
            autoComplete="off"
          />
        </FormControl>
      }
    />
  );
};

MRNInput.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  name: PropTypes.string,
  rowProps: PropTypes.object,
};

export default MRNInput;
